export default "__VITE_ASSET__BerJy_Tn__"